<template>
  <div>
    <div class="head-box">
      <h4>库存明细</h4>
      <div class="c-flex c-flex-item">
        <template v-if="osg.has('ProductInventoryItems,filter-partner')">
          <el-select
            v-model="searchObj.partnerId"
            placeholder="筛选伙伴库存"
            class="screen"
            filterable
            remote
            :remote-method="getPartners"
            clearable
            @clear="
              fpi.page = 1;
              getData();
              getUsersByPartnerId();
            "
            @change="
              fpi.page = 1;
              searchObj.userId = '';
              getData();
              getUsersByPartnerId();
            "
          >
            <el-option
              v-for="item in options.partners"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select
            v-model="searchObj.userId"
            placeholder="筛选入库人员"
            class="screen"
            filterable
            remote
            :remote-method="getUsersByPartnerId"
            clearable
            @clear="
              fpi.page = 1;
              getData();
            "
            @change="
              fpi.page = 1;
              getData();
            "
          >
            <el-option
              v-for="(item, i) in options.users"
              :key="i"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
        <el-select
          v-if="osg.has('ProductInventoryItems,filter-warehouse')"
          v-model="searchObj.warehouseId"
          placeholder="筛选仓库"
          class="screen"
          filterable
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @change="
            fpi.page = 1;
            getData();
          "
        >
          <el-option
            v-for="(item, i) in options.warehouses"
            :key="i"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-input
          placeholder="筛选串码"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <!-- <el-button type="primary" @click="doNew" class="c-m-l-10">入库</el-button> -->
        <el-button
          type="primary"
          class="c-m-l-10"
          v-if="osg.has('ProductInventoryItems,export')"
          @click="
            osg.doExport(
              {
                'fpi-regex:primaryCode|string#or': searchValue,
                'fpi-in:state|array-integer#and': '0,1',
                'fpi-is:partnerId|string#and': searchObj.partnerId,
                'fpi-is:userId|string#and': searchObj.userId,
                beanName: 'productInventoryItem',
                title: '库存明细'
              },
              { dynamic: true }
            )
          "
        >
          数据导出
        </el-button>
        <el-button
          type="primary"
          class="c-m-l-10"
          @click.native="batchAllocation"
          v-if="osg.has('ProductInventoryItems,batchAllocation')"
        >
          批量分配
        </el-button>
        <el-button
          type="primary"
          class="c-m-l-10"
          @click.native="productCodeImport"
          :style="{ display: visibleLine }"
        >
          产品码导入
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter" v-if="osg.has('ProductInventoryItems,filter')">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          v-if="refresh"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
          @selection-change="selectionChange"
        >
          <el-table-column
            type="selection"
            v-if="osg.has('ProductInventoryItems,batchAllocation')"
            fixed
            width="55"
          ></el-table-column>
          <!-- <el-table-column
            prop="primaryCode"
            fixed="left"
            label="库存串码"
            width="150px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="productId"
            label="产品名称"
            width="300px"
            show-overflow-tooltip
            :formatter="formatProduct"
          ></el-table-column>
          <el-table-column
            prop="inventoryStatus"
            label="库存状态"
            :formatter="formatInventoryStatus"
          ></el-table-column>
          <el-table-column prop="count" label="录入次数"></el-table-column>
          <el-table-column
            prop="partnerId"
            label="伙伴"
            :formatter="formatPartnerList"
            width="200px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column prop="createUserName" label="入库人员"></el-table-column>
          <el-table-column prop="createTime" label="入库时间" width="140px"></el-table-column>
          <template v-for="(item, i) in extFields">
            <el-table-column
              :prop="'exts.' + item.name"
              :label="item.nameDisp"
              :key="i"
            ></el-table-column>
          </template> -->
          <c-table :fields="extFields"></c-table>
          <el-table-column
            fixed="right"
            width="100px"
            v-if="osg.has('ProductInventoryItems,column')"
          >
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    @click.native="doEdit(scope.row)"
                    v-if="osg.has('ProductInventoryItems,edit')"
                  >
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 0 && osg.has('ProductInventoryItems,able')"
                    @click.native="doEnable(scope.row._id)"
                  >
                    启用
                  </el-dropdown-item>
                  <el-dropdown-item
                    @click.native="doDisable(scope.row._id)"
                    v-if="scope.row.state == 1 && osg.has('ProductInventoryItems,able')"
                  >
                    禁用
                  </el-dropdown-item>
                  <el-dropdown-item
                    @click.native="doRemove(scope.row._id)"
                    v-if="osg.has('ProductInventoryItems,remove')"
                  >
                    删除
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="库存明细" :visible.sync="openDetail">
      <c-form
        :formData="formData"
        :fields="extFields"
        :options="options"
        ref="form"
        :upload="upload"
        :area="area"
      >
        <template slot="productId">
          <el-select
            v-model="formData.productId"
            clearable
            filterable
            placeholder="可输入产品名称搜索"
          >
            <el-option
              v-for="item in options.products"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
        <!-- <template slot="userId">
          <el-select
            v-model="formData.userId"
            clearable
            filterable
            placeholder="可输入人员姓名搜索"
          >
            <el-option
              v-for="item in options.users"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template> -->
        <template slot="warehouseId">
          <el-select
            v-model="formData.warehouseId"
            clearable
            filterable
            placeholder="可输入仓库名称搜索"
          >
            <el-option
              v-for="item in options.warehouses"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
      </c-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="产品码导入" :visible.sync="dialogImportVisible" width="600px">
      <el-form label-position="center" label-width="170px">
        <el-form-item label="文件">
          <el-upload
            :multiple="false"
            :on-success="onUploadSuccess"
            :action="'fsgo/excel/productCodeImport.do'"
            class="upload-demo"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传Excel文件，且不超过500kb</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogImportVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
window.$this = this;
import areajs from '../../resources/js/area.js';
export default {
  activated() {
    window.$this = this;
  },
  name: 'productInventoryItems',
  data() {
    window.$this = this;
    return {
      selectedList: [],
      visibleLine: 'none',
      dialogImportVisible: false,
      name: 'productInventoryItem',
      refresh: true,
      fpi: {},
      searchValue: '',
      searchObj: {},
      openDetail: false,
      formData: {},
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      options: {
        codecfg_inventoryStatus: { codeId: 'inventoryStatus' }
      },
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      }
    };
  },
  mounted() {
    this.importProductCodeisShow(), this.doInit();
    // this.getPartners();
    // this.getUsersByPartnerId();
    this.osg.getFields('productInventoryItem', () => {
      this.getPartners();
      this.getUsersByPartnerId();
      this.getProducts();
      this.getWarehouses();
      this.osg.getFpi();
      this.getData();
    });
  },
  methods: {
    importProductCodeisShow() {
      this.userinfo = JSON.parse(sessionStorage.getItem('entity'));
      if (this.userinfo.accountName == 'bs@yuhong.com') {
        this.visibleLine = '';
      }
    },
    productCodeImport() {
      this.dialogImportVisible = true;
    },
    // 导入成功后的提醒
    onUploadSuccess(response, file) {
      if (response.success == true) {
        this.$message.info('导入成功');
        this.dialogImportVisible = false;
        this.getData();
      }
      if (response.success == false) {
        this.$message.error(response.message);
      }
    },
    //多选框功能：3.点击多选框的调用函数，这里会将当前已选中的员工记录赋值给selectedList
    selectionChange(rows) {
      this.selectedList = rows;
    },
    batchAllocation() {
      var data = this.selectedList;
      if (data.length > 0) {
        var productItemIds = [];
        this.selectedList.forEach(item => productItemIds.push(item._id));
        productItemIds = productItemIds.join(',');
        let data = { productItemIds: productItemIds };
        this.osg.ajax('/basic/productInventoryItem/batchAllocation.do', data, response => {
          if (response.success == false) {
            this.$message.error(response.message);
          }
          if (response.success == true) {
            this.$message.info('操作成功');
            this.getData();
          }
        });
      } else {
        this.$message.error('未选择产品');
      }
    },
    formatInventoryStatus(row, column, cellValue) {
      return this.osg.codelabel('inventoryStatus', cellValue);
    },
    formatPartnerList(row, column, cellValue) {
      return this.osg.codelabel('partnerList', cellValue);
    },
    formatProduct(row, column, cellValue) {
      return this.osg.codelabel('product', cellValue);
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = { exts: {} };
      this.$util.renderExtField(this.extFields, this.formData);
    },
    getData() {
      let params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        sortField: 'createTime',
        sortOrder: 'desc',
        'regex:primaryCode|string#or': this.searchValue,
        'is:warehouseId|string#or': this.searchObj.warehouseId,
        'is:partnerId|string#and': this.searchObj.partnerId,
        'is:userId|string#and': this.searchObj.userId,
        'in:state|array-integer#and': '0,1'
      };
      //添加过滤器参数
      if (this.osg.has('ProductInventoryItems,filter')) {
        window.$that.getParams(params);
      }
      this.osg.setFpi(params);
      this.osg.ajax('basic/productInventoryItem/query.do', params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doEdit(row) {
      this.$util.renderExtField(this.extFields, row);
      this.formData = row;
      this.openDetail = true;
    },
    doSave() {
      let params = this.$util.deepCopy(this.formData);
      this.$util.saveExtField(this.extFields, params);
      if (this.osg.validate()) {
        this.osg.ajax('basic/productInventoryItem/upsert.do', params, () => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    doEnable(id) {
      this.osg.ajax(`basic/productInventoryItem/enable/${id}.do`, null, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doDisable(id) {
      this.osg.ajax(`basic/productInventoryItem/disable/${id}.do`, null, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doRemove(id) {
      this.osg.confirm('是否确认删除？', () => {
        this.osg.ajax(`basic/productInventoryItem/remove/${id}.do`, null, () => {
          this.osg.toast('删除成功');
          this.getData();
        });
      });
    },
    getProducts(query) {
      this.osg.ajax(
        'basic/product/query.do',
        {
          _all: '1',
          'regex:name|string#or': query,
          'is:state|integer#and': 1
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.products = res.data;
          this.$forceUpdate();
        },
        { noload: true }
      );
    },
    getWarehouses(query) {
      let params = {
        _all: '1',
        'regex:name|string#or': query,
        'regex:code|string#or': query,
        'regex:address|string#or': query,
        'in:state|array-integer#and': '1',
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      this.osg.ajax('basic/wareHouse/query.do', params, res => {
        res.data.map(item => {
          item.label = item.name;
          item.value = item._id;
        });
        this.options.warehouses = res.data;
      });
    },
    //获取伙伴
    getPartners(query) {
      this.osg.ajax(
        'basic/partner/query.do',
        {
          'regex:name|string#and': query,
          _all: '1'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.partners = res.data;
          this.$forceUpdate();
        },
        { noload: true }
      );
    },
    //获取全部伙伴-列表返显
    getPartnerList() {
      this.osg.ajax(
        'basic/partner/query.do',
        {
          _all: '1'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.partnerList = res.data;
          this.$forceUpdate();
        },
        { noload: true }
      );
    },
    getUsersByPartnerId(query) {
      this.osg.ajax(
        'org/query.do',
        {
          'is:partnerId|string#and': this.searchObj.partnerId,
          _all: '1'
        },
        res => {
          let orgIds = [];
          res.data.orgList.map(item => {
            orgIds.push(item._id);
          });

          if (orgIds.length == 0) return;
          let params = {
            'regex:name|string#and': query
          };

          //如果没有筛选伙伴 则不限制orgIds
          if (this.searchObj.partnerId) {
            params['in:orgIds|array#and'] = orgIds.join();
          }

          this.osg.ajax(
            'user/query.do',
            params,
            res => {
              res.data.map(item => {
                item.label = item.name;
                item.value = item._id;
              });
              this.options.users = res.data;
              this.$forceUpdate();
            },
            {
              noload: true
            }
          );
        },
        {
          noload: true
        }
      );
    }
  }
};
</script>
